import { render, staticRenderFns } from "./IconArrowNarrowRightOutline.vue?vue&type=template&id=15336878"
import script from "./IconArrowNarrowRightOutline.vue?vue&type=script&lang=js"
export * from "./IconArrowNarrowRightOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports